import { createContext } from 'react'

import type { EffectiveTheme, ThemePreference } from './theme'

export interface ThemeContextValue {
  /** Cosa ha scelto la persona: chiaro, scuro, o segui il sistema. */
  preference: ThemePreference
  /** Il tema che si vede davvero, con "system" già risolto. */
  effective: EffectiveTheme
  setPreference: (preference: ThemePreference) => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
